var fails = require('../internals/fails');

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/correct-prototype-getter.js
// module id = 123
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 14 15 17 21